import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import '@wppopen/components-library/dist/platform-ui-kit/wpp-theme.css';
import { StandaloneRoot } from './StandaloneRoot';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <StandaloneRoot />,
    </React.StrictMode>,
);

reportWebVitals();
